/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useRef, useContext, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import { useParams, Link, useLocation, useNavigate } from 'react-router-dom';
import { Pathname } from 'Routes';
import { dataFetcher, endpoints, axios, baseUrl } from 'Api';
import { AuthContext, AppContext } from 'Context';
import { v4 as uuid } from 'uuid';
import useSWR from 'swr';
import ReactPlayer from 'react-player';
import screenfull from 'screenfull';
import PermissionDeniedModal from 'Components/PermissionDeniedModal';
import PlayerControls from './PLayerControls';
import HlsPlayer from './HlsPlayer';
import styles from './index.module.css';

const useStyles = makeStyles({
  playerWrapper: {
    width: '100%',
    position: 'relative',
    height: '100vh',
    background: 'black',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
});

const format = (seconds) => {
  if (Number.isNaN(seconds)) {
    return '00:00';
  }
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = date.getUTCSeconds().toString().padStart(2, '0');
  if (hh) {
    return `${hh}:${mm.toString().padStart(2, '0')}:${ss}`;
  }
  return `${mm}:${ss}`;
};
const count = 0;
export function VideoPlayer() {
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  let timeout;

  const location = useLocation();
  const navigate = useNavigate();

  const { setAppSnackbar, subscriptionDetails } = useContext(AppContext);
  const { getToken } = useContext(AuthContext);
  const { videoID, type } = useParams();
  const [loading, setLoading] = useState(true);
  const [videoDetails, setVideoDetails] = useState({});
  const playerRef = useRef(null);
  const [vttContent, setVttContent] = useState(undefined);
  const [spriteImageRow, setSpriteImageRow] = useState(undefined);
  const [spriteImageColumn, setSpriteImageColumn] = useState(undefined);
  const [spriteImageUrl, setSpriteImageUrl] = useState(undefined);
  const [screenSize, setScreenSize] = useState(false);
  const [showPlayAgainButton, setPlayAgainButton] = useState(false);
  const [showControllers, setControllers] = useState(true);
  const [hoverValue, setHoverValue] = useState(null);
  const [nextVideoDetails, setNextVideoDetails] = useState(undefined);
  const [countDown, setCountDown] = useState(10);

  // Video URL fallback logic
  const [currentVideoUrl, setCurrentVideoUrl] = useState(null);
  const [hasTriedFallback, setHasTriedFallback] = useState(false);
  const loadTimeoutRef = useRef(null);

  const [hasPermission, setHasPermission] = useState(true);
  const [showPermissionModal, setShowPermissionModal] = useState(false);

  // Check if user has permission to view this video
  // TODO: TEMPORARY - All access enabled. Revert to original logic when needed.
  useEffect(() => {
    setHasPermission(true); // Temporarily allow all access
    /* ORIGINAL LOGIC - Uncomment to restore:
    // Don't run permission check until subscriptionDetails is loaded
    if (subscriptionDetails === undefined || subscriptionDetails === null) {
      return; // Wait for subscription data to load - keep hasPermission as true (default)
    }

    // If user has upgraded plan (is_locked = 0), allow all videos
    const isLocked = subscriptionDetails?.subscription?.is_locked;
    if (isLocked === '0' || isLocked === 0) {
      setHasPermission(true);
      return;
    }

    // Otherwise, check if video is in allowed list
    const allowedVideoIds = JSON.parse(localStorage.getItem('allowedVideoIds') || '[]');
    const isAllowed = allowedVideoIds.includes(String(videoID));
    setHasPermission(isAllowed);

    if (!isAllowed) {
      setShowPermissionModal(true);
    }
    */
  }, [videoID, subscriptionDetails]);

  const checkUrl = async (url) => {
    try {
      if (url !== '' && url !== null) {
        const res = await fetch(url);
        return res?.status === 200 ? url : null;
      }
      return null;
    } catch (error) {
      return null;
    }
  };
  const { mutate: getVideoDetails } = useSWR(
    [endpoints.getVideosDetail, videoID],
    {
      fetcher: (url, id) => dataFetcher(url, { id }),
      onSuccess: ({ success, data }) => {
        if (success) {
          // Create a copy of the data object to avoid modifying the original
          const newData = { ...data };

          // Check and update each URL separately
          if (data.video_file) {
            checkUrl(data.video_file)
              .then((result) => {
                newData.video_file = result;
              });
          }
          if (data.video_raw_file) {
            checkUrl(data.video_raw_file)
              .then((result) => {
                newData.video_raw_file = result;
              });
          }
          if (data.mp4_url) {
            checkUrl(data.mp4_url)
              .then((result) => {
                newData.mp4_url = result;
              });
          }
          setVideoDetails(newData);

          // Set initial video URL (try primary URL first, fallback to video_raw_file)
          const primaryUrl = newData?.transcoded_url || newData?.video_file || newData?.mp4_url || newData?.video_raw_file;
          // eslint-disable-next-line no-console
          // console.log('🎬 Video URLs available:', {
          //   transcoded_url: newData?.transcoded_url,
          //   video_file: newData?.video_file,
          //   mp4_url: newData?.mp4_url,
          //   video_raw_file: newData?.video_raw_file,
          //   primaryUrl,
          // });
          setCurrentVideoUrl(primaryUrl);

          let nextVideo;
          if (newData?.videos?.length) {
            nextVideo = newData?.videos?.find((element) => element.order_number > data.order_number);
            if (nextVideo) {
              setNextVideoDetails(nextVideo);
            } else {
              setNextVideoDetails(newData?.videos?.[0]);
            }
          }
        } else {
          setAppSnackbar({
            isVisible: true,
            type: 'error',
            message: 'Oops! Something went wrong',
          });
        }

        setLoading(false);
      },
      onError: () => {
        setLoading(false);
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Oops! Something went wrong',
        });
      },
    }
  );
  const { mutate: getVttContent } = useSWR(
    [endpoints.getVttContent, videoID],
    {
      fetcher: (url, video_id) => dataFetcher(url, { video_id }),
      onSuccess: ({ success, data, rows, columns, thumbnail_hover }) => {
        if (success) {
          setVttContent(data);
          setSpriteImageRow(rows);
          setSpriteImageColumn(columns);
          setSpriteImageUrl(thumbnail_hover);
        } else {
          setSpriteImageUrl(null);
        }
        setLoading(false);
      },
      onError: () => {
        navigate(Pathname.access);
        setSpriteImageUrl(null);
        setLoading(false);
      },
    }
  );
  const [state, setState] = useState({
    playing: true,
    muted: false,
    volume: parseFloat(localStorage.getItem('volume')) || 0.5,
    playbackRate: 1.0,
    played: 0,
    seeking: false,
    buffering: true
  });

  useEffect(() => {
    getVideoDetails();
    getVttContent();
  }, [location.pathname]);

  // Set up 10 second timeout for video loading
  useEffect(() => {
    if (currentVideoUrl && !hasTriedFallback) {
      // Clear any existing timeout
      if (loadTimeoutRef.current) {
        clearTimeout(loadTimeoutRef.current);
      }

      // Set 6 second timeout
      // eslint-disable-next-line no-console
      // console.log('⏱️ Starting 6 second timeout for URL:', currentVideoUrl);
      loadTimeoutRef.current = setTimeout(() => {
        // eslint-disable-next-line no-console
        // console.log('⏱️ Timeout fired! hasTriedFallback:', hasTriedFallback, 'video_raw_file:', videoDetails?.video_raw_file);
        // If video hasn't started after 6 seconds, try fallback if available
        if (!hasTriedFallback) {
          if (videoDetails?.video_raw_file) {
            const fallbackUrl = videoDetails.video_raw_file;
            // const fileExtension = fallbackUrl.split('.').pop().toLowerCase();
            // eslint-disable-next-line no-console
            // console.log('🔄 Switching to fallback URL:', fallbackUrl);
            setCurrentVideoUrl(fallbackUrl);
            setHasTriedFallback(true);
          } else {
            // eslint-disable-next-line no-console
            // console.warn('⚠️ No fallback URL available - video is taking too long to load');
          }
        }
      }, 6000);
    }

    // Cleanup timeout on unmount
    return () => {
      if (loadTimeoutRef.current) {
        clearTimeout(loadTimeoutRef.current);
      }
    };
  }, [currentVideoUrl, hasTriedFallback, videoDetails, setAppSnackbar]);

  const classes = useStyles();
  const { playing, muted, volume, playbackRate, played, seeking, buffering } = state;

  const playerContainerRef = useRef(null);
  const controlsRef = useRef(null);

  // Handle video error - fallback to video_raw_file or pause for autoplay
  const handleVideoError = (error) => {
    // eslint-disable-next-line no-console
    // console.log('❌ handleVideoError called:', error);
    // Check if it's an autoplay error - pause video instead
    if (error?.name === 'NotAllowedError' || (error?.message && error.message.includes('interact'))) {
      // eslint-disable-next-line no-console
      // console.log('❌ Autoplay error - pausing video');
      setState((prev) => ({ ...prev, playing: false, buffering: false }));
      return;
    }

    // Clear timeout if it exists
    if (loadTimeoutRef.current) {
      clearTimeout(loadTimeoutRef.current);
      loadTimeoutRef.current = null;
    }

    // Try fallback URL if not already tried
    if (!hasTriedFallback && videoDetails?.video_raw_file) {
      const fallbackUrl = videoDetails.video_raw_file;
      // const fileExtension = fallbackUrl.split('.').pop().toLowerCase();
      // eslint-disable-next-line no-console
      // console.log('❌ Error fallback - switching to:', fallbackUrl);
      setCurrentVideoUrl(fallbackUrl);
      setHasTriedFallback(true);
    }
  };

  // Handle video ready (metadata/manifest loaded - video may not be playing yet)
  const handleVideoReady = () => {
    // eslint-disable-next-line no-console
    // console.log('✅ handleVideoReady called - metadata loaded');
    // Don't clear timeout or hide loader here - wait until video actually starts playing
  };

  // Handle when video actually starts playing
  const handleVideoPlay = () => {
    // eslint-disable-next-line no-console
    // console.log('▶️ handleVideoPlay called - video is playing!');
    // Clear the fallback timeout since video is starting
    if (loadTimeoutRef.current) {
      // eslint-disable-next-line no-console
      // console.log('▶️ Clearing timeout - video is playing');
      clearTimeout(loadTimeoutRef.current);
      loadTimeoutRef.current = null;
    }
    // Don't hide loader here - let handleProgress do it when video has actual progress
    // This ensures loader stays until video frames are actually rendering
    window.gtag?.('event', 'video_play', {
      video_title: videoDetails?.title,
      video_id: videoDetails?.id,
    });
  };

  // state changing codes.....
  const handlePlayPause = () => {
    setState({ ...state, playing: !state.playing });
  };
  const handleRewind = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() - 15);
  };
  const handleFastForward = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() + 15);
  };

  const handleUserKeyPress = (event) => {
    const { key, keyCode } = event;

    if (keyCode === 32) {
      handlePlayPause();
    }
    if (keyCode === 37) { // left arrow key
      handleRewind();
    }
    if (keyCode === 39) { // right arrow key
      handleFastForward();
    }
  };
  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);

    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });
  // show or hide controllers after 3 sec of last mouse move
  const showOrHideControllers = () => {
    if (controlsRef.current && controlsRef.current.style.visibility !== 'visible') {
      controlsRef.current && (controlsRef.current.style.visibility = 'visible');
    }

    if (showPlayAgainButton && !buffering) {
      clearTimeout(timeout);
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (controlsRef.current && controlsRef.current.style.visibility !== 'hidden') {
          controlsRef.current && (controlsRef.current.style.visibility = 'hidden');
          setHoverValue(null);
        }
      }, 2000);
    }
  };

  useEffect(() => {
    // Hide icon after 2 sec after start the video play (without mouse move)
    if (!showPlayAgainButton && !buffering) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (controlsRef.current && controlsRef.current.style.visibility !== 'hidden') {
          controlsRef.current.style.visibility = 'hidden';
          setHoverValue(null);
        }
      }, 2000);

      // Add event listeners only if buffering is false
      ['mousemove', 'click'].forEach((evt) => document.addEventListener(evt, showOrHideControllers, false));

      // Cleanup function to remove event listeners
      return () => {
        ['mousemove', 'click'].forEach((evt) => document.removeEventListener(evt, showOrHideControllers, false));
      };
    }
  }, [showPlayAgainButton, playing, buffering]);

  const handleMute = () => {
    setState({ ...state, muted: !state.muted });
  };
  const handleVolumeChange = (newValue) => {
    newValue === 0 ? setState({
      ...state,
      volume: Math.floor(newValue),
      muted: true,
    })
      : setState({
        ...state,
        volume: Math.floor(newValue),
        muted: false,
      });
  };
  const handleVolumeSeekDown = (newValue) => {
    newValue < 0.027 ? setState({
      ...state,
      volume: 0, // Volume should be 0
      muted: true, // Mute should be true
    })
      : setState({
        ...state,
        volume: newValue,
        muted: false,
      });
  };
  const handelPlaybackRate = (value) => {
    setState({
      ...state,
      playbackRate: value,
    });
  };
  const toggleFullScreen = () => {
    screenfull.toggle(playerContainerRef.current);
    setScreenSize(!screenSize);
  };
  const currentTime = playerRef.current
    ? playerRef.current.getCurrentTime()
    : '00:00';
  const duration = playerRef.current
    ? playerRef.current.getDuration()
    : '00:00';
  const elapsedTime = format(currentTime);
  const totalDuration = format(duration);

  const { mutate: updateVideoPaused } = useSWR(
    [endpoints.updateVideoPaused, videoID, localStorage.getItem('video_duration') || elapsedTime],
    {
      fetcher: (url, video_id, paused_at) => dataFetcher(url, { video_id, paused_at }),
      onSuccess: ({ success, data }) => {
        // if (success) {
        // } else {
        // }
      },
      onError: () => {
      },
    }
  );

  const handleProgress = (changeState) => {
    if (!seeking) {
      // Hide loader when video actually starts playing (has progress)
      if (changeState.playedSeconds > 0 && buffering) {
        // eslint-disable-next-line no-console
        // console.log('📊 handleProgress - hiding loader, playedSeconds:', changeState.playedSeconds);
        setState({ ...state, ...changeState, buffering: false });
      } else {
        setState({ ...state, ...changeState });
      }
    }
    // if (playing) {
    //   updateVideoPaused();
    // }
  };

  useEffect(() => {
    let count = 0;
    if (localStorage?.getItem('video_id') && localStorage?.getItem('video_duration')) {
      window.addEventListener('popstate', async () => {
        if (!count) {
          await axios
            .post(endpoints.updateVideoPaused, { video_id: localStorage.getItem('video_id'), paused_at: localStorage.getItem('video_duration') })
            .then(({ data }) => {
              localStorage.setItem('video_id', null);
              localStorage.setItem('video_duration', null);
            })
            .catch((error) => {
              localStorage.setItem('video_id', null);
              localStorage.setItem('video_duration', null);
            });
          count += 1;
        }
      });
    }
  }, []);
  const elapsedTimeNumber = parseFloat(elapsedTime);
  const apiUrl = `${baseUrl}/updateViewersDetails`;
  const video_id = videoID;
  const token = getToken();
  const [draftId] = useState(uuid());
  const formatTime = (time) => {
    const seconds = Math.floor(time);
    const milliseconds = Math.floor((time - seconds) * 100);
    return `${seconds}.${milliseconds}`;
  };
  const postData = {
    video_id,
    token,
    'uuid': draftId,
    'current': currentTime
  };

  const makeApiCall = async () => {
    if (playing) {
      try {
        const response = await axios.post(apiUrl, postData);
      } catch (error) {
        // Error handling
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(makeApiCall, 10000);
    return () => clearInterval(interval);
  }, [playing]);

  useEffect(() => {
    if (elapsedTime && playing) {
      localStorage.setItem('video_duration', elapsedTime);
      localStorage.setItem('video_id', videoID);
    }
  }, [elapsedTime]);

  const handleSeekChange = (newValue) => {
    setState({ ...state, played: Math.floor(newValue) });
  };
  const handleSeekMouseDown = (e) => {
    setState({ ...state, seeking: true });
  };
  const handleSeekMouseUp = (newValue) => {
    setState({ ...state, seeking: false });
    playerRef.current.seekTo(newValue);
  };

  const onEndBuffering = () => {
    // eslint-disable-next-line no-console
    // console.log('🔄 onEndBuffering called - buffering ended');
    // Clear the fallback timeout but don't hide loader yet - wait for handleVideoPlay
    if (loadTimeoutRef.current) {
      // eslint-disable-next-line no-console
      // console.log('🔄 Clearing timeout in onEndBuffering');
      clearTimeout(loadTimeoutRef.current);
      loadTimeoutRef.current = null;
    }
    // Don't set buffering: false here - let handleVideoPlay do it when video actually plays
  };

  const onStarted = () => {
    type === 'resumeWatching' && playerRef.current.seekTo(playerRef.current.getCurrentTime() + videoDetails.paused_at);
  };

  useEffect(() => {
    if ((currentTime && duration) && currentTime !== '00:00' && currentTime === duration) {
      setTimeout(() => {
        // navigate(-2);
        setPlayAgainButton(true);
      }, 500);
    }
  }, [currentTime]);

  useEffect(() => {
    if (showPlayAgainButton) {
      if (countDown === 1) {
        navigate(
          nextVideoDetails?.id
            ? Pathname.getPlayerPath(nextVideoDetails.id, 'play')
            : Pathname.getVideoPath(videoID)
        );
      }
      // exit early when we reach 0
      if (!countDown) return;

      // save intervalId to clear the interval when the
      // component re-renders
      const intervalId = setInterval(() => {
        setCountDown(countDown - 1);
      }, 1000);
      // clear interval on re-render to avoid memory leaks
      return () => clearInterval(intervalId);
    }
  }, [countDown, showPlayAgainButton, location.pathname]);

  useEffect(() => {
    setTimeout(() => {
      setCountDown(10);
    }, 1000);
  }, [location.pathname]);

  useEffect(() => {
    if (showPlayAgainButton) {
      if (controlsRef.current && controlsRef.current.style.visibility !== 'visible') {
        controlsRef.current && (controlsRef.current.style.visibility = 'visible');
      }
    }
  }, [showPlayAgainButton]);

  // const onEnded = () => {
  // setPlayAgainButton(true);
  // setState({ ...state, playing: false });
  //   setTimeout(() => { navigate(-1); }, 2000);
  // };

  useEffect(() => {
    if (!showPlayAgainButton && currentTime && duration && currentTime !== '00:00' && currentTime === duration) {
      playerRef.current.seekTo(playerRef.current.getCurrentTime() - playerRef.current.getCurrentTime());
      playerRef.current.player.handleReady();
      setState({ ...state, playing: true });
      setCountDown(10);
    }
  }, [showPlayAgainButton]);

  useEffect(() => {
    localStorage.setItem('volume', volume);
  }, [volume]);

  useEffect(() => {
    if (currentTime === 0) {
      setPlayAgainButton(false);
    }
  }, [currentTime]);

  return (
    <>
      <div>
        <div ref={playerContainerRef} className={classes.playerWrapper}>
          <div style={{ position: 'relative', filter: !hasPermission ? 'blur(20px)' : 'none' }}>
            {/* Use custom HLS player for m3u8 URLs to fix audio issues */}
            {/* eslint-disable-next-line no-console */}
            {/* console.log('🎥 Using player:', currentVideoUrl?.includes('.m3u8') ? 'HlsPlayer' : 'ReactPlayer', 'URL:', currentVideoUrl, 'hasPermission:', hasPermission, 'playing:', playing) */}
            {currentVideoUrl?.includes('.m3u8') ? (
              <HlsPlayer
                key={currentVideoUrl}
                ref={playerRef}
                width="100%"
                height="90vh"
                className={styles.react_player}
                style={{ width: '100%', height: '90vh' }}
                url={hasPermission ? currentVideoUrl : null}
                muted={muted}
                playing={hasPermission && playing}
                volume={volume}
                playbackRate={playbackRate}
                onProgress={handleProgress}
                onBufferEnd={onEndBuffering}
                onReady={handleVideoReady}
                onStart={onStarted}
                onError={handleVideoError}
                onPlay={handleVideoPlay}
              />
            ) : (
              <ReactPlayer
                key={currentVideoUrl}
                ref={playerRef}
                width="100%"
                height="90vh"
                className={styles.react_player}
                url={hasPermission ? currentVideoUrl : null}
                muted={muted}
                playing={hasPermission && playing}
                volume={volume}
                playbackRate={playbackRate}
                onProgress={handleProgress}
                onBuffer={() => {
                  // eslint-disable-next-line no-console
                  // console.log('⏳ ReactPlayer onBuffer - video is buffering');
                }}
                onBufferEnd={onEndBuffering}
                onReady={handleVideoReady}
                onStart={onStarted}
                onError={handleVideoError}
                autoPlay={hasPermission}
                onPlay={handleVideoPlay}
                progressInterval={100}
                config={{
                  file: {
                    forceVideo: true,
                  },
                }}
              />
            )}
          </div>
          {/* style={{ display: toolsVesibility ? 'block' : 'none' }} */}
          {hasPermission && (
            <div>
              <PlayerControls
                ref={controlsRef}
                onPlayPause={handlePlayPause}
                playing={playing}
                onRewind={handleRewind}
                onFastForward={handleFastForward}
                muted={muted}
                onMute={handleMute}
                volume={volume}
                onVolumeChange={handleVolumeChange}
                onVolumeSeekUp={handleVolumeSeekDown}
                playbackRate={playbackRate}
                onPlaybackRateChange={handelPlaybackRate}
                onToggleFullScreen={toggleFullScreen}
                played={played}
                onSeek={handleSeekChange}
                onSeekMouseDown={handleSeekMouseDown}
                onSeekMouseUp={handleSeekMouseUp}
                currentTime={currentTime}
                elapsedTime={elapsedTime}
                totalDuration={totalDuration}
                title={videoDetails.title}
                videoID={videoID}
                buffering={buffering}
                vttContent={vttContent}
                duration={duration}
                rows={spriteImageRow}
                columns={spriteImageColumn}
                spriteImage={spriteImageUrl}
                screenSize={screenSize}
                format={format}
                showPlayAgainButton={showPlayAgainButton}
                setPlayAgainButton={setPlayAgainButton}
                showControllers={showControllers}
                setControllers={setControllers}
                hoverValue={hoverValue}
                setHoverValue={setHoverValue}
                setState={setState}
                state={state}
                nextVideoDetails={nextVideoDetails}
                countDown={countDown}
              />
            </div>
          )}
        </div>
      </div>

      {/* Permission Denied Modal */}
      <PermissionDeniedModal
        open={showPermissionModal}
        onClose={() => setShowPermissionModal(false)}
      />
    </>
  );
}
